import React, {ReactElement, Component, Dispatch, SetStateAction, useContext} from 'react';
import {injectIntl} from 'react-intl';
import {withRouter} from "react-router-dom";
import {get_router} from "../common-file/service";
import {Input} from "antd";
import {SearchOutlined} from "@ant-design/icons";
import {SearchValueContext} from "../contexts/search-value";
// import {UserMeContext} from "../contexts/user-me";
import { IUserInfoType, UserInfoContext } from "../../../contexts/user-info";


const SearchValue = (props: any): ReactElement<any, string | (new (props: any) => Component<any, any, any>)>=>{

    const {intl, disabled, placeholder} =props,
        [search_value, set_search_value]: [any, Dispatch<SetStateAction<any>>] = useContext(SearchValueContext),
        user_info: IUserInfoType = useContext(UserInfoContext)[0];
        // user_me: any = useContext(UserMeContext)[0];


    return(
        <Input
            disabled={disabled}
            className={'search-input'}
            defaultValue={search_value[get_router(props, user_info.ssoRole)]}
            prefix={<SearchOutlined />}
            // suffix={<EnterOutlined />}
            placeholder={placeholder? intl.formatMessage({id: 'search_placeholder'}, {name: placeholder}): ''}
            onKeyUp={(e: any)=>{
                const {keyCode, target} = e;
                if(keyCode === 13 || target.value === ''){
                    search_value[get_router(props, user_info.ssoRole)] = target.value;
                    set_search_value({...search_value})
                }
            }}
        />
    )
};

export default injectIntl(withRouter(SearchValue) as any);
